export const triggerNativeLocationAccess = () => {
    if (window.NativeApp) {
        window.NativeApp.handleDetermineUserCurrentLocationTrigger?.();
    } else if (typeof webkit !== "undefined") {
        webkit.messageHandlers?.handleDetermineUserCurrentLocationTrigger?.postMessage(
            ""
        );
    }
};

export const triggerAndroidCheckForLocationPermissions = () => {
    if (window.NativeApp) {
        window.NativeApp.checkLocationPermissions?.();
    }
};

export const triggerCheckForGeneralLocationPermissions = () => {
    if (window.NativeApp) {
        window.NativeApp.checkGeneralLocationPermissions?.();
    } else if (typeof webkit !== "undefined") {
        webkit.messageHandlers?.checkGeneralLocationPermissions?.postMessage(
            ""
        );
    }
};
